
import { Bold, Italic } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Editor } from '@tiptap/react';

export default function FormattingButtons({ editor }: { editor: Editor }) {
  return (
    <>
      <Button
        size="icon"
        variant={editor.isActive('bold') ? 'secondary' : 'ghost'}
        onClick={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleBold().run();
        }}
        className="h-8 w-8"
        title="Bold"
        type="button"
      >
        <Bold className="h-4 w-4" />
      </Button>
      <Button
        size="icon"
        variant={editor.isActive('italic') ? 'secondary' : 'ghost'}
        onClick={(e) => {
          e.preventDefault();
          editor.chain().focus().toggleItalic().run();
        }}
        className="h-8 w-8"
        title="Italic"
        type="button"
      >
        <Italic className="h-4 w-4" />
      </Button>
    </>
  );
}
